

// Haeufige Vertipper bei den grossen Anbietern. Dieselbe Liste steht im Worker
// (/mail/pruefen); hier dient sie nur dazu, den Hinweis sofort zu zeigen, ohne
// auf den Server zu warten. Der Server bleibt die massgebliche Pruefung.
const SUS_TIPPFEHLER = {
  'gmial.com': 'gmail.com', 'gmai.com': 'gmail.com', 'gmail.de': 'gmail.com',
  'gmaill.com': 'gmail.com', 'gmil.com': 'gmail.com', 'gamil.com': 'gmail.com',
  'gmail.co': 'gmail.com', 'googlemail.de': 'googlemail.com',
  'web.e': 'web.de', 'wen.de': 'web.de', 'wb.de': 'web.de', 'web.d': 'web.de',
  'gmx.e': 'gmx.de', 'gmx.d': 'gmx.de', 'gnx.de': 'gmx.de',
  'hotmai.com': 'hotmail.com', 'hotmial.com': 'hotmail.com', 'hotmail.de': 'hotmail.com',
  'outlok.com': 'outlook.com', 'outllok.com': 'outlook.com',
  'yaho.com': 'yahoo.com', 'yahooo.com': 'yahoo.com',
  't-onlne.de': 't-online.de', 't-online.com': 't-online.de',
  'freent.de': 'freenet.de', 'arcor.com': 'arcor.de',
};
// Bewusst streng: mindestens ein Punkt nach dem @ und zwei Buchstaben am Ende.
// "name@gmail" oder "a@b" kommen damit gar nicht erst bis zum Server.
const SUS_MAIL_FORM = /^[^@\s]+@([a-z0-9]([a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,}$/i;

function susMailBrauchbar(wert) {
  return SUS_MAIL_FORM.test(String(wert || '').trim());
}

function susMailVorschlag(wert) {
  const teile = String(wert || '').trim().toLowerCase().split('@');
  if (teile.length !== 2) return null;
  const ziel = SUS_TIPPFEHLER[teile[1]];
  return ziel ? teile[0] + '@' + ziel : null;
}

/*
  Stoff und Stahl — „Kostenlos testen" (Phase 2).

  Der ganze Weg auf einer Seite: Angaben, drei Fotos, Vorschau, Kauf.

  Warum die Fotoumwandlung hier noch einmal steht und nicht aus dem
  Personalisierungsblock geholt wird: Jener Block haengt am Kaufknopf einer
  laufenden Produktseite und ist mehrfach ausdruecklich als „nicht anfassen"
  gekennzeichnet. Eine gemeinsame Datei haette beide Seiten gekoppelt. Die
  Werte (lange Kante, Budget, Mindestmass) kommen hier aus data-Attributen,
  damit sie wenigstens an einer Stelle gepflegt werden — im Theme-Editor.

  Die drei Fotos gehen direkt an den Worker, nicht ueber Shopify.
*/
(() => {
  const wurzel = document.querySelector('[data-sus-vorschau]');
  if (!wurzel) return;

  const BASIS = (wurzel.dataset.basis || '').replace(/\/$/, '');
  const MIN_KANTE = Number(wurzel.dataset.minKante) || 500;
  const MAX_KANTE = Number(wurzel.dataset.maxKante) || 3500;
  const BUDGET = (Number(wurzel.dataset.budgetMb) || 15) * 1024 * 1024;
  const ANSICHTEN = ['front', 'seite', 'heck'];
  // So heissen die drei Ansichten fuer den Kunden. Eine Meldung mit „front, seite,
  // heck" waere unsere Sprache, nicht seine.
  const NAMEN = { front: 'von vorn', seite: 'von der Seite', heck: 'von hinten' };

  const lese = (name, rueckfall) => {
    const el = wurzel.querySelector(`[data-sus-${name}]`);
    if (!el) return rueckfall;
    try { return JSON.parse(el.textContent); } catch (e) { return rueckfall; }
  };
  const PRODUKTE = lese('produkte', {});
  const STANDARDTEXTE = lese('standardtexte', {});
  const LADETEXTE = lese('ladetexte', ['Wir rechnen …']);
  const FARBLISTE = lese('farbliste', '');

  const q = (s, w = wurzel) => w.querySelector(s);
  const qa = (s, w = wurzel) => Array.from(w.querySelectorAll(s));

  const formular = q('[data-sus-formular]');
  const laedt = q('[data-sus-laedt]');
  const laedtText = q('[data-sus-laedt-text]');
  const laedtZeit = q('[data-sus-laedt-zeit]');
  const ergebnis = q('[data-sus-ergebnis]');
  const bild = q('[data-sus-bild]');
  const fehlerFeld = q('[data-sus-fehler]');
  const kaufFehler = q('[data-sus-kauffehler]');
  const textarea = q('[data-sus-infotext]');
  const zaehler = q('[data-sus-zaehler]');
  const mailFeld = q('[data-sus-mail]');
  const mailTipp = q('[data-sus-mailtipp]');
  const startKnopf = q('[data-sus-start]');
  const kaufKnopf = q('[data-sus-kauf]');

  // Der Knopf bleibt gesperrt, bis die Adresse brauchbar aussieht (26.10.2026).
  // Sie ist Pflicht und der einzige Weg zur Vorschau; ein Klick ohne sie wuerde
  // nur eine Absage vom Server einhandeln. Bei einem erkannten Vertipper in der
  // Domain steht darueber ein Vorschlag, den ein Klick uebernimmt.
  function vsMailWache() {
    const wert = mailFeld ? mailFeld.value : '';
    const gut = susMailBrauchbar(wert);
    if (startKnopf) startKnopf.disabled = !gut;

    const ziel = susMailVorschlag(wert);
    if (!mailTipp) return;
    if (ziel) {
      mailTipp.textContent = 'Meintest du ';
      const a = document.createElement('button');
      a.type = 'button';
      a.className = 'sus-vs__tippknopf';
      a.textContent = ziel.split('@')[1] + '?';
      a.addEventListener('click', () => {
        mailFeld.value = ziel;
        mailTipp.hidden = true;
        vsMailWache();
        mailFeld.focus();
      });
      mailTipp.appendChild(a);
      mailTipp.hidden = false;
    } else {
      mailTipp.textContent = '';
      mailTipp.hidden = true;
    }
  }
  if (mailFeld) {
    mailFeld.addEventListener('input', vsMailWache);
    mailFeld.addEventListener('blur', vsMailWache);
    vsMailWache();
  }

  // Kommt der Besucher mit ?v= zurueck (Kauf-Link aus der Mail, Produktseite),
  // ist nichts davon neu — dann wird auch nichts gemessen.
  const suche = new URLSearchParams(location.search);
  const ausRueckkehr = !!suche.get('v') && suche.get('neu') !== '1';

  const zustand = {
    produktart: 'hoodie',
    farbe: null,          // { name, hex }
    modell: null,
    fotos: {},            // ansicht -> { datei, breite, hoehe }
    kennung: null,
    variante: null,
    rabattcode: new URLSearchParams(location.search).get('rabatt') || null,
  };

  /* ---------------------------------------------------------------- Farben */

  // Farbe eines Variantentitels: „L / Deep Black" -> „Deep Black"
  const farbeAusTitel = (titel) => {
    const teile = String(titel || '').split('/');
    return teile.length > 1 ? teile[teile.length - 1].trim() : '';
  };

  // Hexwerte aus der Theme-Einstellung „Name = #Hex", eine je Zeile.
  const HEX = {};
  String(FARBLISTE || '').split(/\r?\n/).forEach((zeile) => {
    const m = zeile.match(/^\s*(.+?)\s*=\s*(#[0-9A-Fa-f]{6})\s*$/);
    if (m) HEX[m[1].toLowerCase()] = m[2].toUpperCase();
  });

  const farbenVon = (art) => {
    const gesehen = new Map();
    ((PRODUKTE[art] || {}).varianten || []).forEach((v) => {
      const name = farbeAusTitel(v.titel);
      if (name && !gesehen.has(name)) gesehen.set(name, HEX[name.toLowerCase()] || '#888888');
    });
    return Array.from(gesehen, ([name, hex]) => ({ name, hex }));
  };

  const groessenVon = (art, farbe) =>
    ((PRODUKTE[art] || {}).varianten || [])
      .filter((v) => farbeAusTitel(v.titel) === farbe)
      .map((v) => ({ ...v, groesse: String(v.titel).split('/')[0].trim() }));

  /* ------------------------------------------------------------- Oberflaeche */

  const zeige = (el, an) => { if (el) el.hidden = !an; };
  const fehler = (text) => {
    if (!fehlerFeld) return;
    fehlerFeld.textContent = text || '';
    zeige(fehlerFeld, !!text);
    if (text) fehlerFeld.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  const kachelnSetzen = (behaelter, wert) => {
    qa('.sus-vs__kachel', behaelter).forEach((k) => {
      k.setAttribute('aria-pressed', String(k.dataset.wert === wert));
    });
  };

  const farbenZeichnen = () => {
    const liste = farbenVon(zustand.produktart);
    if (!zustand.farbe || !liste.some((f) => f.name === zustand.farbe.name)) {
      zustand.farbe = liste[0] || null;
    }
    [q('[data-sus-farben]'), q('[data-sus-farben-neu]')].forEach((behaelter) => {
      if (!behaelter) return;
      behaelter.innerHTML = '';
      liste.forEach((f) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'sus-vs__farbe';
        b.dataset.wert = f.name;
        b.style.setProperty('--farbe', f.hex);
        b.setAttribute('aria-pressed', String(!!zustand.farbe && f.name === zustand.farbe.name));
        b.innerHTML = `<i></i><span>${f.name}</span>`;
        b.addEventListener('click', () => {
          zustand.farbe = f;
          farbenZeichnen();
          groessenZeichnen();
          if (zustand.kennung && behaelter.hasAttribute('data-sus-farben-neu')) farbeNeuRechnen();
        });
        behaelter.appendChild(b);
      });
    });
  };

  const groessenZeichnen = () => {
    const behaelter = q('[data-sus-groessen]');
    if (!behaelter || !zustand.farbe) return;
    const liste = groessenVon(zustand.produktart, zustand.farbe.name);
    behaelter.innerHTML = '';
    zustand.variante = null;
    liste.forEach((v) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'sus-vs__groesse';
      b.dataset.wert = String(v.id);
      b.textContent = v.groesse;
      b.disabled = !v.verfuegbar;
      b.setAttribute('aria-pressed', 'false');
      b.addEventListener('click', () => {
        zustand.variante = v;
        qa('.sus-vs__groesse', behaelter).forEach((x) =>
          x.setAttribute('aria-pressed', String(x === b)));
        preisSetzen(v.preis);
      });
      behaelter.appendChild(b);
    });
    const erste = liste.find((v) => v.verfuegbar);
    preisSetzen(erste ? erste.preis : null);
  };

  const preisSetzen = (cent) => {
    if (!kaufKnopf) return;
    const grund = kaufKnopf.dataset.text || kaufKnopf.textContent.trim();
    kaufKnopf.dataset.text = grund;
    kaufKnopf.textContent = cent
      ? `${grund} für ${(cent / 100).toFixed(2).replace('.', ',')} €`
      : grund;
  };

  /* ------------------------------------------------------------------ Fotos */

  const masse = (datei) => new Promise((fertig, schief) => {
    const url = URL.createObjectURL(datei);
    const i = new Image();
    i.onload = () => { URL.revokeObjectURL(url); fertig({ breite: i.naturalWidth, hoehe: i.naturalHeight }); };
    i.onerror = () => { URL.revokeObjectURL(url); schief(new Error('unlesbar')); };
    i.src = url;
  });

  const alsJpeg = (datei, kante, guete = 0.92) => new Promise((fertig, schief) => {
    const url = URL.createObjectURL(datei);
    const i = new Image();
    i.onload = () => {
      URL.revokeObjectURL(url);
      const f = Math.min(1, kante / Math.max(i.naturalWidth, i.naturalHeight));
      const c = document.createElement('canvas');
      c.width = Math.round(i.naturalWidth * f);
      c.height = Math.round(i.naturalHeight * f);
      c.getContext('2d').drawImage(i, 0, 0, c.width, c.height);
      c.toBlob((b) => b ? fertig(new File([b], datei.name.replace(/\.\w+$/, '') + '.jpg',
        { type: 'image/jpeg' })) : schief(new Error('Umwandeln misslungen')), 'image/jpeg', guete);
    };
    i.onerror = () => { URL.revokeObjectURL(url); schief(new Error('unlesbar')); };
    i.src = url;
  });

  const summe = () => Object.values(zustand.fotos).reduce((a, f) => a + f.datei.size, 0);

  // Reissen die drei Fotos zusammen das Budget, werden sie stufenweise kleiner
  // gerechnet — und zwar aus dem Original, nicht aus dem schon komprimierten JPEG.
  const budgetHalten = async () => {
    if (summe() <= BUDGET) return true;
    for (const kante of [3000, 2500, 2000]) {
      for (const a of ANSICHTEN) {
        const f = zustand.fotos[a];
        if (!f) continue;
        try {
          f.datei = await alsJpeg(f.quelle, kante, 0.88);
        } catch (e) {
          // Nur hinsehen: Der Fehler wird unveraendert weitergegeben, damit sich
          // am Verhalten nichts aendert.
          panne('budget_verkleinern', e, {
            ansicht: a, bytes: f.quelle.size, format: f.quelle.type,
            breite: f.breite, hoehe: f.hoehe, kante,
          });
          merken(e);
          throw e;
        }
      }
      if (summe() <= BUDGET) return true;
    }
    panne('budget_zu_gross', 'Summe ' + summe() + ' ueber ' + BUDGET, { bytes: summe() });
    return false;
  };

  // Der Text im leeren Feld ist eine Einstellung; das Skript darf ihn nicht
  // zweitens festlegen.
  const LEERTEXT = (q('[data-sus-fotostand]') || {}).textContent || 'Foto wählen';

  const fotoStand = (ansicht, text, gut) => {
    const feld = q(`[data-sus-fotofeld="${ansicht}"]`);
    if (!feld) return;
    const stand = q('[data-sus-fotostand]', feld);
    if (stand) stand.textContent = text;
    feld.classList.toggle('ist-gut', !!gut);
    feld.classList.toggle('ist-schlecht', text && !gut);
  };

  qa('[data-sus-datei]').forEach((eingabe) => {
    eingabe.addEventListener('change', async () => {
      const ansicht = eingabe.dataset.susDatei;
      const datei = eingabe.files && eingabe.files[0];
      if (!datei) {
        delete zustand.fotos[ansicht];
        fotoStand(ansicht, LEERTEXT, false);
        return;
      }
      fotoStand(ansicht, 'wird geprüft …', false);
      let m = null;
      try {
        m = await masse(datei);
        if (Math.max(m.breite, m.hoehe) < MIN_KANTE) {
          delete zustand.fotos[ansicht];
          fotoStand(ansicht, `zu klein (${m.breite}×${m.hoehe})`, false);
          panne('foto_zu_klein', 'unter ' + MIN_KANTE + ' px', {
            ansicht, bytes: datei.size, format: datei.type, breite: m.breite, hoehe: m.hoehe,
          });
          return;
        }
        const klein = await alsJpeg(datei, MAX_KANTE);
        zustand.fotos[ansicht] = { datei: klein.size < datei.size ? klein : datei, quelle: datei, ...m };
        fotoStand(ansicht, 'passt', true);
        fehler('');
      } catch (e) {
        delete zustand.fotos[ansicht];
        fotoStand(ansicht, 'nicht lesbar', false);
        panne('foto_verkleinern', e, {
          ansicht, bytes: datei.size, format: datei.type,
          breite: m && m.breite, hoehe: m && m.hoehe,
        });
      }
    });
  });

  /* -------------------------------------------------------------- Infotext */

  const standardtextSetzen = () => {
    if (!textarea || !zustand.modell) return;
    const text = STANDARDTEXTE[zustand.modell] || '';
    textarea.value = text;
    if (zaehler) zaehler.textContent = String(text.length);
  };

  if (textarea) {
    textarea.addEventListener('input', () => {
      if (zaehler) zaehler.textContent = String(textarea.value.length);
    });
    // Leer verlassen füllt sichtbar wieder mit dem Standardtext. Es gibt keine
    // Bestellung ohne Text — leer heisst also immer: Standardtext.
    textarea.addEventListener('blur', () => {
      if (textarea.value.trim() === '') standardtextSetzen();
    });
  }

  /* --------------------------------------------------------------- Messung */

  const melden = (ereignis) => {
    if (!zustand.kennung && ereignis !== 'test_gestartet') return;
    // Automatische Laeufe zaehlen nicht mit, siehe utm_source=test in Teil 5.
    if (/[?&]utm_source=test(&|$)/.test(location.search)) return;
    try {
      // Als Abfrageparameter, ohne Rumpf: ein Beacon mit application/json loest
      // eine CORS-Vorabanfrage aus, die er nicht fuehren kann — der Browser wirft
      // ihn dann weg, ohne dass es jemand merkt (19.10.2026).
      const ziel = `${BASIS}/webhook/vorschau/ereignis`
        + `?ereignis=${encodeURIComponent(ereignis)}`
        + (zustand.kennung ? `&kennung=${encodeURIComponent(zustand.kennung)}` : '');
      navigator.sendBeacon
        ? navigator.sendBeacon(ziel)
        : fetch(ziel, { method: 'POST', keepalive: true });
    } catch (e) { /* Messung darf nie den Weg aufhalten */ }
  };

  /* ------------------------------------------------------- Pannen melden */

  // Erkennung von Geraet und Browser steht in stoffundstahl-panne.js, damit sie
  // nicht an drei Einstiegen gepflegt werden muss. Fehlt die Datei, passiert
  // nichts — gemeldet wird nur, nichts geheilt.
  const panne = (schritt, fehler, zusatz) => {
    if (window.susPanne) {
      window.susPanne(BASIS, schritt, fehler,
        { ...(zusatz || {}), quelle: 'vorschauseite', kennung: zustand.kennung || '' });
    }
  };

  // Eine Panne wird genau einmal gemeldet: Wer sie selbst meldet, markiert den
  // Fehler, und das Auffangnetz in starten() laesst ihn dann liegen.
  const merken = (e) => { try { e.sus_gemeldet = true; } catch (x) { /* egal */ } return e; };
  const gemeldet = (e) => !!(e && e.sus_gemeldet);

  /* ----------------------------------------------------------------- Ablauf */

  let ladeUhr = null;
  const ladeAnzeige = (an) => {
    zeige(laedt, an);
    if (an) schrittSetzen(2);
    if (!an) { clearInterval(ladeUhr); ladeUhr = null; return; }
    const start = Date.now();
    let i = 0;
    laedtText.textContent = LADETEXTE[0];
    ladeUhr = setInterval(() => {
      const s = Math.round((Date.now() - start) / 1000);
      if (laedtZeit) laedtZeit.textContent = `${s} s`;
      if (s > 4 && i < LADETEXTE.length - 1 && s % 6 === 0) {
        i += 1;
        laedtText.textContent = LADETEXTE[i];
      }
    }, 1000);
  };

  const hol = async (pfad, daten) => {
    const antwort = await fetch(`${BASIS}${pfad}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(daten),
    });
    return antwort.json();
  };

  // Der Zustand kommt vom Server, nicht aus dem Formular. Beim Weg ueber ?v=
  // (Kauf-Link aus der Mail) ist das die einzige Quelle; nach dem Formular sind
  // es dieselben Werte, also schadet es nicht.
  const zustandUebernehmen = (stand) => {
    if (!stand) return;
    if (stand.produktart && PRODUKTE[stand.produktart]) zustand.produktart = stand.produktart;
    if (stand.modell) zustand.modell = stand.modell;
    if (stand.farbe_name) zustand.farbe = { name: stand.farbe_name, hex: stand.farbe_hex || '#888888' };
    if (stand.infotext && textarea && !textarea.value.trim()) textarea.value = stand.infotext;
    if (stand.rabattcode && !zustand.rabattcode) zustand.rabattcode = stand.rabattcode;
    kachelnSetzen(q('[data-sus-produkt]'), zustand.produktart);
    kachelnSetzen(q('[data-sus-modell]'), zustand.modell);
  };

  const schrittSetzen = (nr) => {
    qa('.sus-vs__schritt').forEach((li) => {
      li.classList.toggle('ist-aktiv', Number(li.dataset.schritt) === nr);
      li.classList.toggle('ist-vorbei', Number(li.dataset.schritt) < nr);
    });
  };

  const ergebnisZeigen = (stand) => {
    zustandUebernehmen(stand);
    schrittSetzen(3);
    bild.src = stand.bild;
    zeige(ergebnis, true);
    zeige(formular, false);
    ladeAnzeige(false);
    farbenZeichnen();
    groessenZeichnen();
    ergebnis.scrollIntoView({ behavior: 'smooth', block: 'start' });
    // Nur der eigene Lauf zaehlt. Ein zweiter Aufruf ueber ?v= waere derselbe
    // Mensch und wuerde die Wochentabelle schoenrechnen.
    if (!ausRueckkehr) melden('vorschau_gezeigt');
  };

  const warten = async (kennung) => {
    const bis = Date.now() + 5 * 60 * 1000;
    let erste = true;
    while (Date.now() < bis) {
      // Beim ersten Durchgang nicht warten: eine fertige Vorschau (Kauf-Link aus
      // der Mail) soll sofort stehen, nicht nach 2,5 Sekunden.
      if (!erste) await new Promise((r) => setTimeout(r, 2500));
      erste = false;
      let stand;
      try {
        stand = await (await fetch(`${BASIS}/webhook/vorschau/stand?kennung=${encodeURIComponent(kennung)}`)).json();
      } catch (e) { continue; }
      if (stand.fertig && stand.bild) return ergebnisZeigen(stand);
      if (stand.fehler) {
        ladeAnzeige(false);
        zeige(formular, true);
        schrittSetzen(1);
        return fehler(stand.text || 'Das hat leider nicht geklappt.');
      }
      if (stand.text) laedtText.textContent = stand.text;
    }
    ladeAnzeige(false);
    zeige(formular, true);
    fehler('Das dauert länger als gewöhnlich. Wir schicken dir die Vorschau per Mail, sobald sie fertig ist.');
  };

  const starten = async (ereignis) => {
    if (ereignis) ereignis.preventDefault();
    fehler('');

    if (!zustand.modell) return fehler('Bitte wähle dein Modell.');
    const fehlende = ANSICHTEN.filter((a) => !zustand.fotos[a]);
    if (fehlende.length) {
      return fehler('Es fehlen noch Fotos: ' + fehlende.map((a) => NAMEN[a]).join(', ') + '.');
    }
    if (!mailFeld.value || !/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(mailFeld.value)) {
      return fehler('Bitte gib eine Mailadresse an, an die wir die Vorschau schicken dürfen.');
    }

    startKnopf.disabled = true;
    zeige(formular, false);
    ladeAnzeige(true);
    if (laedt) laedt.scrollIntoView({ behavior: 'smooth', block: 'center' });
    melden('test_gestartet');

    try {
      if (!(await budgetHalten())) {
        throw merken(new Error(
          'Deine Fotos sind zusammen zu groß. Nimm bitte etwas kleinere Aufnahmen.'));
      }

      const an = await hol('/webhook/vorschau/anmelden', {
        mail: mailFeld.value.trim(),
        modell: zustand.modell,
        produktart: zustand.produktart,
        farbe_name: zustand.farbe.name,
        farbe_hex: zustand.farbe.hex,
        infotext: textarea ? textarea.value : '',
        min_kante: MIN_KANTE,
        quelle: 'vorschauseite',
        rabattcode: zustand.rabattcode,
      });
      if (!an.ok) {
        panne('anmelden_abgelehnt', an.text || 'ohne Grund', {});
        throw merken(new Error(an.text || 'Das hat gerade nicht geklappt.'));
      }
      zustand.kennung = an.kennung;

      const paket = new FormData();
      paket.append('kennung', an.kennung);
      paket.append('ablauf', an.ablauf);
      paket.append('ticket', an.ticket);
      paket.append('min_kante', String(an.min_kante || MIN_KANTE));
      ANSICHTEN.forEach((a) => paket.append(a, zustand.fotos[a].datei));

      // Der Upload bekommt einen zweiten Versuch, und danach geht es in jedem Fall
      // weiter. Grund: Am 19.10.2026 lagen bei einem Kunden alle drei Fotos auf dem
      // Server, der Browser hatte die Antwort aber verloren — damit wurde
      // vorschau/los nie gerufen und der Auftrag blieb fuer immer stehen, ohne dass
      // jemand davon erfuhr. Der Upload schreibt immer dieselben drei Dateien, ein
      // zweiter Versuch kostet also nichts und kann nichts doppeln.
      let hoch = null;
      for (let versuch = 1; versuch <= 2 && !hoch; versuch += 1) {
        try {
          hoch = await (await fetch(an.upload_url, { method: 'POST', body: paket })).json();
        } catch (e) {
          panne('upload_versuch_' + versuch, e, { bytes: summe(), format: 'image/jpeg' });
          if (versuch === 2) break;
          await new Promise((r) => setTimeout(r, 1500));
        }
      }
      // Der stille Fall aus dem Vorfall vom 19.10.2026: beide Versuche ohne
      // Antwort. Die Fotos koennen trotzdem auf dem Server liegen.
      if (!hoch) panne('upload_ohne_antwort', 'zwei Versuche ohne Antwort', { bytes: summe() });
      if (hoch && hoch.zu_klein && hoch.zu_klein.length) {
        panne('upload_zu_klein', hoch.zu_klein.join(','), { bytes: summe() });
        throw merken(new Error('Diese Fotos sind zu klein: '
          + hoch.zu_klein.map((a) => NAMEN[a] || a).join(', ') + '.'));
      }
      if (hoch) melden('fotos_hochgeladen');

      // Auch ohne Antwort weiterfahren: Entweder sind die Fotos doch angekommen,
      // dann laeuft alles normal. Oder nicht, dann scheitert die Verarbeitung
      // sichtbar und der Kunde bekommt die Mail aus WF27.
      await hol('/webhook/vorschau/los', { kennung: an.kennung });
      history.replaceState(null, '', `?v=${encodeURIComponent(an.kennung)}`);
      await warten(an.kennung);
    } catch (e) {
      if (!gemeldet(e)) panne('start', e, { bytes: summe() });
      ladeAnzeige(false);
      zeige(formular, true);
      schrittSetzen(1);
      fehler(e.message || 'Das hat gerade nicht geklappt.');
    } finally {
      startKnopf.disabled = false;
    }
  };

  const farbeNeuRechnen = async () => {
    if (!zustand.kennung || !zustand.farbe) return;
    bild.style.opacity = '0.45';
    try {
      const a = await hol('/webhook/vorschau/farbe', {
        kennung: zustand.kennung,
        farbe_name: zustand.farbe.name,
        farbe_hex: zustand.farbe.hex,
        produktart: zustand.produktart,
      });
      if (a.ok && a.bild) bild.src = a.bild;
    } finally {
      bild.style.opacity = '';
    }
  };

  const kaufen = async () => {
    if (!zustand.kennung) return;
    const v = zustand.variante;
    if (!v) {
      kaufFehler.textContent = 'Bitte wähle erst deine Größe.';
      zeige(kaufFehler, true);
      const kasten = q('[data-sus-groessen]');
      if (kasten) kasten.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    zeige(kaufFehler, false);
    kaufKnopf.disabled = true;
    melden('kaufen_geklickt');
    try {
      // Dieselben Namen wie der Personalisierungsblock. Sie heissen ueberall so:
      // in der Warenkorbseite und in WF1 bei der Bestellannahme. Mit eigenen
      // Namen (frueher _foto_seite) fand der Warenkorb die Fotos nicht, hielt an
      // und sagte dem Kunden, seine Personalisierung sei weg (20.10.2026).
      // Ohne fuehrenden Unterstrich sind sie ausserdem sichtbar, der Kunde sieht
      // seine Fotos also im Warenkorb und im Checkout.
      const eig = {
        'Modell': zustand.modell,
        'Infotext': textarea ? textarea.value : '',
        'Bildrechte': 'ja',
        '_vorschau': zustand.kennung,
        '_min_kante': String(MIN_KANTE),
        '_personalisiert_am': new Date().toISOString(),
      };
      const FOTO_NAMEN = { seite: 'Foto Seite', front: 'Foto Front', heck: 'Foto Heck' };
      ANSICHTEN.forEach((a) => {
        eig[FOTO_NAMEN[a]] = `${BASIS}/vorschau/foto/${zustand.kennung}/${a}.jpg`;
      });
      const antwort = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: 1, properties: eig }] }),
      });
      if (!antwort.ok) throw new Error('Das Teil ließ sich nicht in den Warenkorb legen.');
      const ziel = zustand.rabattcode
        ? `/checkout?discount=${encodeURIComponent(zustand.rabattcode)}`
        : '/cart';
      location.href = ziel;
    } catch (e) {
      kaufFehler.textContent = e.message;
      zeige(kaufFehler, true);
      kaufKnopf.disabled = false;
    }
  };

  /* ------------------------------------------------------------------ Start */

  qa('[data-sus-produkt] .sus-vs__kachel').forEach((k) => {
    k.addEventListener('click', () => {
      zustand.produktart = k.dataset.wert;
      kachelnSetzen(q('[data-sus-produkt]'), k.dataset.wert);
      farbenZeichnen();
      groessenZeichnen();
      if (zustand.kennung) farbeNeuRechnen();
    });
  });

  qa('[data-sus-modell] .sus-vs__kachel').forEach((k) => {
    k.addEventListener('click', () => {
      zustand.modell = k.dataset.wert;
      kachelnSetzen(q('[data-sus-modell]'), k.dataset.wert);
      if (!textarea.value.trim()) standardtextSetzen();
    });
  });

  if (formular) formular.addEventListener('submit', starten);
  if (kaufKnopf) kaufKnopf.addEventListener('click', kaufen);

  farbenZeichnen();
  schrittSetzen(1);

  // Mit ?v=<kennung> gleich die fertige Vorschau zeigen (Kauf-Link aus der Mail,
  // Rueckkehr von der Produktseite).
  const vorhanden = new URLSearchParams(location.search).get('v');
  if (vorhanden) {
    zustand.kennung = vorhanden;
    zeige(formular, false);
    ladeAnzeige(true);
    warten(vorhanden);
  }
})();
